import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'scenes/App/App';
import { BrowserRouter } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import * as serviceWorker from './serviceWorker';

function render(Component) {
	ReactDOM.render(
		<AppContainer>
			<BrowserRouter>
				<Component />
			</BrowserRouter>
		</AppContainer>,
		document.getElementById('root'),
	);
}

render(App);
serviceWorker.unregister();
